export default __webpack_public_path__ + "static/media/step1.7776944f.png";